import { render } from "./ToggleIcon.vue?vue&type=template&id=fddb5cce&scoped=true"
import script from "./ToggleIcon.vue?vue&type=script&lang=js"
export * from "./ToggleIcon.vue?vue&type=script&lang=js"

import "./ToggleIcon.vue?vue&type=style&index=0&id=fddb5cce&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fddb5cce"]])

export default __exports__